const ITEMS = ["$POWEEN", "SMALL DOG BIG DREAMS", "CA AT LAUNCH", "SOLANA MOONSHOT", "PUPOWEENWIFHAT", "PUMPKIN SZN"];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div data-testid="marquee" className="relative overflow-hidden border-y border-purple-500/20 bg-[#151022] py-5">
            <div className="animate-marquee flex w-max items-center gap-10">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center gap-10">
                        {row.map((t, i) => (
                            <span key={`${half}-${i}`} className="flex items-center gap-10">
                                <span
                                    className={`font-spooky whitespace-nowrap text-3xl sm:text-4xl ${
                                        i % 2 === 0 ? "text-stroke-orange" : "text-purple-400/60"
                                    }`}
                                >
                                    {t}
                                </span>
                                <span className="text-orange-500/70">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
